import { render, staticRenderFns } from "./serveB.vue?vue&type=template&id=8be06fae&scoped=true&"
import script from "./serveB.vue?vue&type=script&lang=js&"
export * from "./serveB.vue?vue&type=script&lang=js&"
import style0 from "./serveB.vue?vue&type=style&index=0&id=8be06fae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be06fae",
  null
  
)

export default component.exports